import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import { PROCESS_TYPE } from 'features/sendouts/constants/constants';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

const buildCreateSendoutAlert = ({ severity, body }) => ({
  severity,
  title: strings.formatString(strings.sendoutsV2.alerts.submitMessages[severity].title, {
    processType: PROCESS_TYPE.Sendout.title,
    action: severity === 'success' ? 'Created' : 'Creating'
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const createSendout = async ({ jobOrderId, payload }) => {
  try {
    const response = await API.post(
      Endpoints.JobOrderSendouts.replace(':id', jobOrderId),
      payload,
      { apiVersion: 2 }
    );

    if (response.status !== HTTPStatusCodes.Created) {
      return {
        success: false,
        response,
        alert: buildCreateSendoutAlert({
          severity: 'error',
          body: `Unexpected response status: ${response.status}`
        })
      };
    }

    return { success: true, response, alert: buildCreateSendoutAlert({ severity: 'success' }) };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildCreateSendoutAlert({
        severity: 'error',
        body: getErrorMessage(error, error?.message ?? 'Something went wrong')
      })
    };
  }
};
